var map = {
	"./info-slide-1.jpeg": 1257,
	"./info-slide-2.jpeg": 889,
	"./info-slide-3.jpeg": 7392,
	"./info-slide-4.jpeg": 5024,
	"./prac-info-slide-5.jpeg": 3626,
	"./prac-info-slide-6.jpeg": 7912,
	"./prac-info-slide-7.jpeg": 8421,
	"./prac-info-slide-8.jpeg": 7170,
	"./prac-info-slide-9.jpeg": 1357
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;